import { VISIBLE_FOCUSABLE } from './const';

export default function (containerElement = null) {
	const $ = jQuery;
	const queryResults = (arguments.length === 0) ? $(VISIBLE_FOCUSABLE) : $(containerElement).find(VISIBLE_FOCUSABLE);
	const focusableElements = [];
	for (let i = 0; i < queryResults.length; i++) {
		const element = queryResults.get(i);
		// Filter invisible links or screen-reader only links
		const isInvisible = element.className.includes('da11y-screen-reader-text')
			|| element.className.includes('sr-only')
			|| ($(element).css('visibility') === 'hidden')
			|| (($(element).css('height') === '1px') && ($(element).css('width') === '1px'))
			|| (element.type && (element.type === 'hidden'));
		if (!isInvisible) {
			focusableElements.push(queryResults.get(i));
		}
	}

	focusableElements.sort((a, b) => {
		const TabIndexA = parseInt(a.getAttribute('tab-index'), 10);
		const TabIndexB = parseInt(b.getAttribute('tab-index'), 10);
		if (TabIndexA < TabIndexB) {
			return -1;
		} else if (TabIndexA > TabIndexB) {
			return 1;
		}
		return 0;
	});
	return focusableElements;
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/focus/get-all-focusables.js